
import React, { useEffect } from 'react'
import { Box, Grid } from '@mui/material';
import { Markup } from 'interweave';


export const ComponentToPrint = React.forwardRef((props, ref) => {

    useEffect(() => {
        console.log(props.datos)
    }, [props])

    useEffect(() => {
        console.log(props.datosUsuario)
    }, [props])


    return (
        <>
            <div ref={ref}>


                {
                    props.datos.map((x) =>
                        <Box style={{ padding: "3rem", fontSize: "12px", pageBreakAfter: "always" }}>
                            <Box style={{ marginTop: "10px" }}>
                                <Grid style={{ border: "1px solid black" }} container rowSpacing={1} columnSpacing={{ xs: 0 }}>

                                    <Grid style={{ padding: "5px", border: "1px solid black", textAlign: "center" }} item xs={3}>
                                        <img style={{ width: "100px" }} src="/static/images/img/logoLogin.png" alt="Imgen clinica vesalio" />
                                    </Grid>

                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={5}>
                                        <div style={{ textAlign: "center", marginTop: "15px" }}><b>INDICACIONES TERAPÉUTICAS (TRATAMIENTO)</b></div>
                                    </Grid>

                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={4}>
                                        <Box style={{ marginTop: "10px" }}>
                                            <Grid style={{}} container rowSpacing={1} columnSpacing={{ xs: 0 }}>
                                                <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={6}>
                                                    <div>Código:</div>
                                                </Grid>
                                                <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={6}>
                                                    <div style={{ fontSize: "12px" }}>FO - DMED - 04</div>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        <Box style={{ marginTop: "10px" }}>
                                            <Grid style={{}} container rowSpacing={1} columnSpacing={{ xs: 0 }}>
                                                <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={6}>
                                                    <div>Versión:</div>
                                                </Grid>
                                                <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={6}>
                                                    <div style={{ textAlign: "center" }}>02</div>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>

                                </Grid>
                            </Box>

                            <Box style={{ marginTop: "15px" }}>
                                <Grid style={{}} container columnGap={0} columnSpacing={{ xs: 0 }}>
                                    <Grid style={{ padding: "5px", border: "1px solid black", backgroundColor: "#fff" }} item xs={5}>
                                        <div style={{ textAlign: "left" }}>Nombres y Apellidos del paciente:</div>
                                    </Grid>
                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={7}>
                                        <div style={{ textAlign: "left" }}>{props.datosUsuario.Des_Nombres + ' ' + props.datosUsuario.Des_ApePaterno + ' ' + props.datosUsuario.Des_ApeMaterno }</div>
                                    </Grid>
                                </Grid>
                            </Box>


                            <Box style={{ marginTop: "15px" }}>
                                <Grid style={{}} container columnGap={0} columnSpacing={{ xs: 0 }}>
                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={1.5}>
                                        <div style={{ textAlign: "left", marginTop: "10px" }}>N° de H.C.:</div>
                                    </Grid>
                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={1.5}>
                                        <div style={{ textAlign: "left", marginTop: "10px" }}>{props.datosUsuario.Nro_Historia}</div>
                                    </Grid>
                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={1.5}>
                                        <div style={{ textAlign: "left", marginTop: "10px" }}>N° de Cama:</div>
                                    </Grid>
                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={1.5}>
                                        <div style={{ textAlign: "left", marginTop: "10px" }}>{' '}</div>
                                    </Grid>
                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={1.5}>
                                        <div style={{ textAlign: "left", marginTop: "10px" }}>Edad:</div>
                                    </Grid>
                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={1.5}>
                                        {console.log(parseInt(new Date().toISOString().toString().split('T')[0]))}
                                        {console.log(parseInt(props.datosUsuario.Fec_Nacimien.split('T')[0]))}
                                        <div style={{ textAlign: "left", marginTop: "10px" }}>{parseInt(new Date().toISOString().toString().split('T')[1]) > parseInt(props.datosUsuario.Fec_Nacimien.split('T')[1]) ? parseInt(new Date().toISOString().toString().split('T')[0])-parseInt(props.datosUsuario.Fec_Nacimien.split('T')[0]) : parseInt(new Date().toISOString().toString().split('T')[0])-parseInt(props.datosUsuario.Fec_Nacimien.split('T')[0]) - 1}</div>
                                    </Grid>
                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={1.5}>
                                        <div style={{ textAlign: "left", marginTop: "10px" }}>Sexo:</div>
                                    </Grid>
                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={1.5}>
                                        <div style={{ textAlign: "center", border: "1px solid black", backgroundColor: props.datosUsuario.Des_Sexo === 'M' ? "#00f" : "transparent" }}>M</div>
                                        <div style={{ textAlign: "center", border: "1px solid black", backgroundColor: props.datosUsuario.Des_Sexo === 'F' ? "#55f" : "transparent" }}>F</div>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box style={{ marginTop: "15px" }}>
                                <Grid style={{}} container columnGap={0} columnSpacing={{ xs: 0 }}>
                                    <Grid style={{ padding: "5px", border: "1px solid black", backgroundColor: "#fff" }} item xs={4}>
                                        <div style={{ textAlign: "left", paddingBottom: "20px" }}>Datos a Registrar:</div>
                                        <div style={{ textAlign: "left" }}>1. Fecha y Hora</div>
                                        <div style={{ textAlign: "left" }}>2. Dieta</div>
                                        <div style={{ textAlign: "left" }}>3. Cuidados de enfermería u otros profesionales</div>
                                        <div style={{ textAlign: "left" }}>4. Medicamentos (considerar presentación, dosis, frecuencia y vía de administración).</div>
                                        <div style={{ textAlign: "left" }}>5. Firma, sello y número de colegiatura del médico.</div>
                                    </Grid>
                                    <Grid style={{ padding: "5px", border: "1px solid black" }} item xs={8}>
                                        <div style={{ textAlign: "left" }}><i>Fecha y Hora:</i></div>
                                        <div style={{ textAlign: "left" }}> <Markup content={x.alergias} /> </div>
                                        <div style={{ textAlign: "left" }}> <Markup content={x.alergias} /> </div>
                                        <div style={{ textAlign: "left" }}> <Markup content={x.alergias} /> </div>
                                        <div style={{ textAlign: "left" }}> <Markup content={x.alergias} /> </div>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    )
                }



            </div>
        </>
    )
})